// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__238ro","head":"styles_head__1_HI6","body":"styles_body__pcjmy"};